import React, { useEffect, useState } from "react";
import moment from "moment";
import { DateRangePicker } from "rsuite";
import CardLayout from "../../common/cardLayout/CardLayout";
import { Bar } from "react-chartjs-2";
import { InfoCard } from "../dashboard/DashboardHome";
import {
  fetchAssessmentCountPerDayLogic,
  fetchFlagTypeCountPerDay,
  fetchDepressionRemission,
  fetchImprovementForAssessment,
} from "../../../store/features/patient/assessmentsSlice";
import { notify } from "../../../util/helpers";
import RedFlag from "../../../assets/icons/red-alert-flag.svg";
import yellowAlertFlag from "../../../assets/icons/yellow-alert-flag.svg";
import greenAlertFlag from "../../../assets/icons/green-alert-flag.svg";
import InfoIcon from "../../../assets/icons/info.svg";
import { CTooltip } from "@coreui/react";
import DetailedInfoCard from "./DetailedInfoCard";

const BehavioralHealthMetrics = (props) => {
  const { afterToday } = DateRangePicker;
  const [startDate, setStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [dateRange, setDateRange] = useState([
    moment().startOf("Month").toDate(),
    moment().toDate(),
  ]);
  const [redFlagCount, setRedFlagCount] = useState(0);
  const [yellowFlagCount, setYellowFlagCount] = useState(0);
  const [greenFlagCount, setGreenFlagCount] = useState(0);
  const [labelData, setLabelData] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [depressionRemissionRate, setDepressionRemissionRate] = useState(0);
  const [PHQ9Data, setPHQ9Data] = useState(0);
  const [PHQ8Data, setPHQ8Data] = useState(0);
  const [GAD7Data, setGAD7Data] = useState(0);
  const [PHQAData, setPHQAData] = useState(0);

  const getAssessmentValues = (arrayData) => {
    //take array of dates and return week-day wise count
    const finalObject = {};
    const arrayObjects = Object.keys(arrayData);
    const arrayValues = Object.values(arrayData);

    var result = [];
    if (arrayObjects && arrayObjects.length > 0) {
      arrayObjects.forEach((item, index) => {
        result.push({ key: item, value: arrayValues[index] });
      });
    }

    result.forEach((element) => {
      const arrayObjectsInside = Object.keys(element.value);
      const arrayValuesInside = Object.values(element.value);

      var resultInside = [];
      if (arrayObjectsInside && arrayObjectsInside.length > 0) {
        arrayObjectsInside.forEach((item, index) => {
          resultInside.push({ key: item, value: arrayValuesInside[index] });
        });
      }

      resultInside.forEach((element) => {
        if (finalObject[element.key])
          finalObject[element.key] = finalObject[element.key] + element.value;
        else finalObject[element.key] = element.value;
      });
    });

    return finalObject;
  };

  useEffect(() => {
    setStartDate(moment(dateRange[0]).format("YYYY-MM-DD"));
    setEndDate(moment(dateRange[1]).format("YYYY-MM-DD"));
  }, [dateRange]);
  const handleDateRangeSelect = (dateRange) => {
    setDateRange(dateRange);
  };
  useEffect(() => {
    fetchFlagTypeCountPerDay({
      clinic_id: props?.user?.clinic?.id,
      start_date: startDate,
      end_date: endDate,
    })
      .then((res) => {
        const formatted = { YELLOW: 0, RED: 0, GREEN: 0 };
        Object.values(res.data).forEach((item) => {
          if ("YELLOW" in item) {
            formatted["YELLOW"] += item["YELLOW"];
          }
          if ("RED" in item) {
            formatted["RED"] += item["RED"];
          }
          if ("null" in item) {
            formatted["GREEN"] += item["null"];
          }
        });
        setYellowFlagCount(formatted["YELLOW"]);
        setRedFlagCount(formatted["RED"]);
        setGreenFlagCount(formatted["GREEN"]);
      })
      .catch((e) => {
        notify("Something went wrong", e);
      });
    fetchAssessmentCountPerDayLogic({
      clinic_id: props?.user?.clinic?.id,
      start_date: startDate,
      end_date: endDate,
      date_range: true,
    })
      .then((res) => {
        setLabelData(Object.keys(getAssessmentValues(res.data)));
        setChartData(Object.values(getAssessmentValues(res.data)));
      })
      .catch((e) => {
        notify("Something went wrong", e);
      });
    fetchDepressionRemission({
      clinic_id: props?.user?.clinic?.id,
      start_date: startDate,
      end_date: endDate,
    })
      .then((res) => {
        setDepressionRemissionRate(res.data.remission_rate);
      })
      .catch((e) => {
        notify("Something went wrong", "Error");
      });
    if (process.env.REACT_APP_DASHBOARD_TYPE === "youth"){
      fetchImprovementForAssessment({
        assessment_id: 21,
        clinic_id: props?.user?.clinic?.id,
        start_date: startDate,
        end_date: endDate,
      })
        .then((res) => {
          setPHQAData(res?.data?.patients_list.length);
        })
        .catch((e) => {
          notify("Something went wrong", "Error");
        });
        fetchImprovementForAssessment({
          assessment_id: 8,
          clinic_id: props?.user?.clinic?.id,
          start_date: startDate,
          end_date: endDate,
        })
          .then((res) => {
            setPHQ9Data(res?.data?.patients_list.length);
          })
          .catch((e) => {
            notify("Something went wrong", "Error");
          });
          fetchImprovementForAssessment({
            assessment_id: 14,
            clinic_id: props?.user?.clinic?.id,
            start_date: startDate,
            end_date: endDate,
          })
            .then((res) => {
              setGAD7Data(res?.data?.patients_list.length);
            })
            .catch((e) => {
              notify("Something went wrong", "Error");
            });
    }else {
      fetchImprovementForAssessment({
        assessment_id: 9,
        clinic_id: props?.user?.clinic?.id,
        start_date: startDate,
        end_date: endDate,
      })
        .then((res) => {
          setPHQ9Data(res?.data?.patients_list.length);
        })
        .catch((e) => {
          notify("Something went wrong", "Error");
        });
        fetchImprovementForAssessment({
          assessment_id: 6,
          clinic_id: props?.user?.clinic?.id,
          start_date: startDate,
          end_date: endDate,
        })
          .then((res) => {
            setPHQ8Data(res?.data?.patients_list.length);
          })
          .catch((e) => {
            notify("Something went wrong", "Error");
          });
          fetchImprovementForAssessment({
            assessment_id: 7,
            clinic_id: props?.user?.clinic?.id,
            start_date: startDate,
            end_date: endDate,
          })
            .then((res) => {
              setGAD7Data(res?.data?.patients_list.length);
            })
            .catch((e) => {
              notify("Something went wrong", "Error");
            });
    }
  }, [startDate, endDate]);
  const redFlagSpan = (
    <span>
      <i className="fas fa-circle text-danger"></i>
    </span>
  );
  const data = {
    labels: labelData,
    datasets: [
      {
        label: "",
        backgroundColor: "#00008B",
        borderColor: "#00008B",
        data: chartData,
      },
    ],
  };
  const BarChart = () => {
    return (
      <Bar
        data={data}
        options={{
          responsive: true,
          plugins: { legend: { display: false } },
          scales: {
            x: {
              grid: {
                display: false,
              },
            },
            y: {
              beginAtZero: true,

              type: "linear",

              grid: {
                display: true,
              },
            },
          },
        }}
      />
    );
  };

  return (
    <>
      <div className="row container-fluid px-2 py-2">
        <div className="d-flex container-fluid w-100">
          <DateRangePicker
            placeholder="Select Date Range"
            onChange={handleDateRangeSelect}
            shouldDisableDate={afterToday()}
            value={dateRange}
          />
        </div>
      </div>
      <div className="row container-fluid px-2 py-2">
        <div
          className=" col-sm-6 col-md-6 col-lg-6"
          style={{
            margin: "0px",
            padding: "0px",
            border: "5px solid transparent",
            boxSizing: "border-box",
            backgroundClip: "padding-box",
          }}
        >
          <CardLayout
            className="container-fluid  px-2"
            style={{
              boxShadow: " 0px 5px 10px rgba(80, 110, 131, 0.19)",
            }}
          >
            <div className="d-flex justify-content-between container-fluid w-100 ">
              <div>
                <h5 style={{ textAlign: "left", color: "gray" }}>Flag Count</h5>
              </div>
              <div>
                <CTooltip content="Flag Count">
                  <img
                    style={{ cursor: "pointer" }}
                    src={InfoIcon}
                    height="15px"
                    width="15px"
                    alt="Information Icon"
                  />
                </CTooltip>
              </div>
            </div>

            <div className="d-flex justify-content-between container-fluid w-100 ">
              <div>
                <span
                  className="px-2 "
                  style={{
                    textAlign: "left",
                    fontSize: "30px",
                    color: "black",
                  }}
                >
                  {redFlagCount}
                </span>
                <img src={RedFlag} height="16px" width="16px" alt="Red Flag" />{" "}
                <span>Red Flags</span>
              </div>
              <div>
                <span
                  className="px-2 "
                  style={{
                    textAlign: "left",
                    fontSize: "30px",
                    color: "black",
                  }}
                >
                  {yellowFlagCount}
                </span>
                <img
                  src={yellowAlertFlag}
                  height="16px"
                  width="16px"
                  alt="Red Flag"
                />{" "}
                <span>Yellow Flags</span>
              </div>
              <div>
                <span
                  className="px-2 "
                  style={{
                    textAlign: "left",
                    fontSize: "30px",
                    color: "black",
                  }}
                >
                  {greenFlagCount}
                </span>
                <img
                  src={greenAlertFlag}
                  height="16px"
                  width="16px"
                  alt="Red Flag"
                />{" "}
                <span>Green Flags</span>
              </div>
            </div>
          </CardLayout>
        </div>
        <div
          className=" col-sm-3 col-md-3 col-lg-3 "
          style={{
            margin: "0px",
            padding: "0px",
            border: "5px solid transparent",
            boxSizing: "border-box",
            backgroundClip: "padding-box",
          }}
        >
          <DetailedInfoCard
            title={"Depression Remission Rate"}
            stats={depressionRemissionRate || 0 + "%"}
            information={(process.env.REACT_APP_DASHBOARD_TYPE === "youth" ?
              "Percent of patients who reached depression remission (PHQ-A or PHQ-9 ≤ 4)"
              :
             "Percent of patients who reached depression remission (PHQ-9 ≤ 4)")}
            show_link={false}
            spanText={(process.env.REACT_APP_DASHBOARD_TYPE === "youth" ?
              "Percent of patients who reached depression remission (PHQ-A or PHQ-9 ≤ 4)"
              :
             "Percent of patients who reached depression remission (PHQ-9 ≤ 4)")}
            style={{ height: "130px" }}
          />
        </div>
        <div
          className=" col-sm-3 col-md-3 col-lg-3"
          style={{
            margin: "0px",
            padding: "0px",
            border: "5px solid transparent",
            boxSizing: "border-box",
            backgroundClip: "padding-box",
          }}
        >
          <DetailedInfoCard
            title={"Patient Satisfaction Score"}
            stats={"14/18"}
            information={"Patient Satisfaction Score"}
            show_link={false}
            spanText={""}
            style={{ height: "130px" }}
          />
        </div>
      </div>
      <div className="row container-fluid px-2 py-2">
        <div
          className=" col-sm-6 col-md-6 col-lg-6"
          style={{
            margin: "0px",
            padding: "0px",
            border: "5px solid transparent",
            boxSizing: "border-box",
            backgroundClip: "padding-box",
          }}
        >
          <CardLayout
            className="container-fluid  px-2"
            style={{
              boxShadow: " 0px 5px 10px rgba(80, 110, 131, 0.19)",
            }}
          >
            <div className="d-flex justify-content-between container-fluid w-100 ">
              <div>
                <h5 style={{ textAlign: "left", color: "gray" }}>
                  Assessment being Administered
                </h5>
              </div>
              <div>
                <CTooltip content="Flag Count">
                  <img
                    style={{ cursor: "pointer" }}
                    src={InfoIcon}
                    height="15px"
                    width="15px"
                    alt="Information Icon"
                  />
                </CTooltip>
              </div>
            </div>
            <div
              className="container-fluid w-100 mt-5"
              style={{ height: "fit-content" }}
            >
              <BarChart />
            </div>
          </CardLayout>
        </div>
        <div
          className=" col-sm-6 col-md-6 col-lg-6"
          style={{
            margin: "0px",
            padding: "0px",
            border: "5px solid transparent",
            boxSizing: "border-box",
            backgroundClip: "padding-box",
          }}
        >
           {process.env.REACT_APP_DASHBOARD_TYPE === "youth" ? (
            <DetailedInfoCard
            title={"PHQ-A or PHQ-9 Improvement"}
            stats={PHQAData + PHQ9Data}
            information={"Number of patients who increase by 6 points in the PHQ-A or PHQ-9 assessment in the date range"}
            show_link={false}
            spanText={"Number of patients who increase by 6 points in the PHQ-A or PHQ-9 assessment in the date range"}
            style={{ height: "150px" }}
          />
           ):(
            <DetailedInfoCard
            title={"PHQ-8 or PHQ-9 Improvement"}
            stats={PHQ8Data + PHQ9Data}
            information={
              "Number of patients who increase by 6 points in the PHQ-8 or PHQ-9 assessment in the date range"
            }
            show_link={false}
            spanText={
              "Number of patients who increase by 6 points in the PHQ-8 or PHQ-9 assessment in the date range"
            }
            style={{ height: "150px" }}
          />
           )}
          
          <DetailedInfoCard
            title={"GAD-7 Improvement"}
            stats={GAD7Data}
            information={
              "Number of patients who increase by 6 points in the GAD-7 assessment in the date range"
            }
            show_link={false}
            style={{ margin: "10px 0px" }}
            spanText={
              "Number of patients who increase by 6 points in the GAD-7 assessment in the date range"
            }
          />
          <DetailedInfoCard
            title={"Total Patients Improved"}
            // stats={PHQ8Data + PHQ9Data + GAD7Data}
            stats={(process.env.REACT_APP_DASHBOARD_TYPE === "youth" ? PHQAData : PHQ8Data) + PHQ9Data + GAD7Data}
            information={(process.env.REACT_APP_DASHBOARD_TYPE === "youth" ?
              "Number of patients (excluding duplicates) who increase by 6 points in the PHQ-A, PHQ-9 or GAD-7 assessment in the date range"
              :
              "Number of patients (excluding duplicates) who increase by 6 points in the PHQ-8, PHQ-9 or GAD-7 assessment in the date range")}
            show_link={false}
            spanText={
              (process.env.REACT_APP_DASHBOARD_TYPE === "youth" ?
                "Number of patients (excluding duplicates) who increase by 6 points in the PHQ-A, PHQ-9 or GAD-7 assessment in the date range"
                :
                "Number of patients (excluding duplicates) who increase by 6 points in the PHQ-8, PHQ-9 or GAD-7 assessment in the date range")
            }
            style={{ height: "170px" }}
          />
        </div>
      </div>
    </>
  );
};

export default BehavioralHealthMetrics;
